import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, type AppLocale } from './types';

type LocaleState = {
  locale: AppLocale;
  setLocale: (locale: AppLocale) => void;
};

function isAppLocale(value: unknown): value is AppLocale {
  return value === 'zh-CN' || value === 'en-US';
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: DEFAULT_LOCALE,
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: LOCALE_STORAGE_KEY,
      partialize: (state) => ({ locale: state.locale }),
      merge: (persisted, current) => {
        const saved = persisted as Partial<LocaleState> | undefined;
        const locale = isAppLocale(saved?.locale) ? saved.locale : current.locale;
        return { ...current, locale };
      },
    },
  ),
);
